keyFieldsFnFromSpecifier